export default __webpack_public_path__ + "static/media/banner2b.7dd9213d.jpg";